import { render } from "./Header.vue?vue&type=template&id=f4a97fba&scoped=true"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=f4a97fba&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4a97fba"]])

export default __exports__